import React from "react";
import MapImage from "./map.image.v1";
import Suspense from "src/components/suspense";

const MapboxMap = React.lazy(() => import('./map.mapbox.v1'));



export default class MapV1 extends React.Component<MapProps> {
    static defaultProps : Partial<MapProps> = {
        desktopWidth: 1200,
        mobileWidth: 400,
    }

    render() {
        const {
            desktopWidth, desktopHeight, mobileWidth, mobileHeight,
            latitude, longitude, zoom,
            disableInteractivity, openModalMapOnClick, showLocationMarker,
        } = this.props;

        if (!latitude || !longitude || 
            isNaN(latitude) || isNaN(longitude) ||
            latitude < -90 || latitude > 90 ||
            longitude < -180 || longitude > 180) {
            return null;
        }

        return <>
            <Suspense fallback={<MapImage 
                                    desktopWidth={desktopWidth} desktopHeight={desktopHeight}
                                    mobileWidth={mobileWidth} mobileHeight={mobileHeight}
                                    latitude={latitude} longitude={longitude} zoom={zoom}
                                />}>
                <MapboxMap
                    desktopHeight={desktopHeight} mobileHeight={mobileHeight}
                    latitude={latitude} longitude={longitude} zoom={zoom}
                    disableInteractivity={disableInteractivity}
                    openModalMapOnClick={openModalMapOnClick}
                    showLocationMarker={showLocationMarker}
                />
            </Suspense>
        </>
    }
}